import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { AngularSplitModule } from 'angular-split';
import { isTerminalOpen } from '../../../stores/ui/ui.selector';
import { RawComponent } from '../../room/raw/raw.component';

@Component({
  selector: 'era-overview-split',
  templateUrl: './overview-split.container.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSplitModule, RouterOutlet, RawComponent],
})
export class OverviewSplitContainerComponent {
  private readonly store = inject(Store);

  public readonly isTerminalOpen = this.store.selectSignal(isTerminalOpen);
}
